import { Action } from 'redux';

export enum StaleOfflineCleanupActionKeys {
	SET_STALE_IDS = '@@staleOfflineCleanup/SET_STALE_IDS',
	DISMISS_FOR_SESSION = '@@staleOfflineCleanup/DISMISS_FOR_SESSION',
	SET_CLEANING_UP = '@@staleOfflineCleanup/SET_CLEANING_UP',
	SET_AUTO_CLEAN_ENABLED = '@@staleOfflineCleanup/SET_AUTO_CLEAN_ENABLED',
	SET_PREFERENCES_LOADED = '@@staleOfflineCleanup/SET_PREFERENCES_LOADED',
	CLEAR = '@@staleOfflineCleanup/CLEAR',
}

interface SetStaleIdsAction extends Action {
	type: StaleOfflineCleanupActionKeys.SET_STALE_IDS;
	staleIds: number[];
}

interface DismissForSessionAction extends Action {
	type: StaleOfflineCleanupActionKeys.DISMISS_FOR_SESSION;
}

interface SetCleaningUpAction extends Action {
	type: StaleOfflineCleanupActionKeys.SET_CLEANING_UP;
	isCleaningUp: boolean;
}

interface SetAutoCleanEnabledAction extends Action {
	type: StaleOfflineCleanupActionKeys.SET_AUTO_CLEAN_ENABLED;
	autoCleanEnabled: boolean;
}

interface SetPreferencesLoadedAction extends Action {
	type: StaleOfflineCleanupActionKeys.SET_PREFERENCES_LOADED;
	preferencesLoaded: boolean;
}

interface ClearStaleOfflineCleanupAction extends Action {
	type: StaleOfflineCleanupActionKeys.CLEAR;
}

export type StaleOfflineCleanupAction = SetStaleIdsAction
	| DismissForSessionAction
	| SetCleaningUpAction
	| SetAutoCleanEnabledAction
	| SetPreferencesLoadedAction
	| ClearStaleOfflineCleanupAction;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/StaleOfflineCleanup/typings.ts